import { render } from "./NegociosHero.vue?vue&type=template&id=26f78990&scoped=true"
import script from "./NegociosHero.vue?vue&type=script&lang=js"
export * from "./NegociosHero.vue?vue&type=script&lang=js"

import "./NegociosHero.vue?vue&type=style&index=0&id=26f78990&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f78990"]])

export default __exports__